module.exports = __webpack_public_path__ + "assets/img/preview.f19711532197fff0f85579a52c9ba3e4.png";